// extracted by mini-css-extract-plugin
module.exports = {"InfoButton":"InfoButton_InfoButton__1ymjF"};